/* eslint-disable @typescript-eslint/naming-convention */
/**
 * Simple decorator that binds a method to the instance of the class it belongs to.
 */
export function Bound(_, property_key, descriptor) {
    return {
        get: function () {
            const bound = descriptor.value.bind(this);
            Object.defineProperty(this, property_key, {
                value: bound,
                configurable: true,
                writable: true
            });
            return bound;
        },
        configurable: true
    };
}
//# sourceMappingURL=Bound.js.map